module.exports = __webpack_public_path__ + "img/text_boxes-01.ebd0fdd6.png";